// ----------------------------------------------------------------------
// <copyright file="Izenda.LicenseCheckerConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

export default {
  LICENSE_KEY: {
    Alerting: 'Alerting',
    Form: 'Form',
    Dashboard: 'Dashboard',
    ReportTemplateComponent: 'Report Templates',
    Scheduling: 'Scheduling',
    Exporting: 'Exporting',
    ReportDesigner: 'Report Designer',
    Charting: 'Charting',
    Maps: 'Maps',
    MachineLearning:'Machine Learning',
    Iframe: 'I-Frame',
    Nlq:'NLQ'
  },
  get MESSAGE() {
    return {
      MG02: localizer.getText('LICENSE_CHECKER_MESSAGE_CONNECTION_STRING_INVALID'),
      MG04: localizer.getText('LICENSE_CHECKER_MESSAGE_CONNECT_ERROR'),
      MG05: localizer.getText('LICENSE_CHECKER_MESSAGE_CANNOT_OPEN_DATABASE'),
      MG06: localizer.getText('LICENSE_CHECKER_MESSAGE_LOGIN_FAILED'),
      MG07: localizer.getText('LICENSE_CHECKER_MESSAGE_CONFIRM_OVERRIDE_CONNECTION_STRING'),
      MG08: localizer.getText('LICENSE_CHECKER_MESSAGE_INVALID_CONNECTION_STRING')
    };
  },
  get Description() {
    return localizer.getText('LICENSE_CHECKER_MESSAGE_CONNECTION_STRING_DESCRIPTION');
  },
  SERVER_TYPE: {
    MSSQL: '572bd576-8c92-4901-ab2a-b16e38144813',
    UNKNOWN: '00000000-0000-0000-0000-000000000000'
  },
  CONNECTION_STRING_CONSTRAINT: {
    presence: {
      presence: true,
      get message() {
        return localizer.getText('LICENSE_CHECKER_MESSAGE_CONNECTION_STRING_CONSTRAINT');
      }
    }
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.LicenseCheckerConstants.js